import { DishSectionType } from '../../../../../store/api/dish-section-api';
import { useDishMenuStore } from '../../../../../store/use-dish-menu-store';
import { getCurrentMenu } from './menu-informer-helpers';

export const createMenuSection = (section: DishSectionType) => {
  getCurrentMenu()?.sections?.splice(0, 0, section);

  useDishMenuStore.setState((prev) => ({
    menu: {
      ...prev.menu,
      sections: [section, ...(prev.menu?.sections || [])],
    },
  }));
};

export const updateMenuSection = (section: DishSectionType) => {
  const updated = getCurrentMenu()?.sections?.map((item) =>
    item.id === section.id ? section : item,
  );

  useDishMenuStore.setState((prev) => ({
    menu: {
      ...prev.menu,
      sections: updated,
    },
  }));
};

export const deleteMenuSection = (sectionId: string) => {
  const menu = getCurrentMenu();
  if (!menu) return;
  const filtered = menu?.sections?.filter((item) => String(item.id) !== sectionId);
  const updatedMenu = { ...menu, sections: filtered };

  useDishMenuStore.setState((prev) => ({
    menu: updatedMenu,
    menuList: prev.menuList?.map((item) => (item.id === updatedMenu.id ? updatedMenu : item)),
  }));
};

export const sortMenuSections = (order?: number[]) => {
  if (!order) return;
  getCurrentMenu()?.sections?.sort((a, b) => order.indexOf(a.id) - order.indexOf(b.id));
};
